import "./index.scss";

import React, { useEffect, useState } from "react";

import { getChangelog } from "../../modules/message/messageServices";
import Changelog from "../Changelog";

const VersionLabel = () => {
  const [showChangelog, setShowChangelog] = useState(false);
  const [version, setVersion] = useState("");
  const [changelog, setChangelog] = useState([]);

  useEffect(() => {
    fetch("meta.json")
      .then((response) => response.json())
      .then((json) => {
        console.log(`version is ${json.version}`);
        setVersion(json.version);
      });
    getChangelogData();
  }, []);

  const getChangelogData = async () => {
    const response = await getChangelog();
    if (response.changelog) {
      setChangelog(response.changelog);
      setVersion(response.changelog[0].version.toString());
      if (response.currentVersion !== response.changelog[0].version) {
        setShowChangelog(true);
      }
    }
  };

  return (
    <>
      <div id="bottom" className="version">
        <h5 onClick={() => setShowChangelog(true)} style={{ cursor: "pointer" }}>
          v{version}
        </h5>
      </div>
      <Changelog data={changelog} open={showChangelog} onClose={() => setShowChangelog(false)} />
    </>
  );
};

export interface IChangelogData {
  version: string | number;
  date: string;
  content: any;
}

export default VersionLabel;
